import { translate } from '../../../i18n/I18nProvider';
import { isDefined } from '../../../utils/isDefined';
import { translateLabel } from '../actions/translateActions';
import DefaultDetailRow from './DefaultDetailRow';

const SUBSCRIPTION_FIELDS = ['name', 'delivery_address'];

const SubscriptionDetails = ({ item, classes, el, accountName }) => {
  const {
    account,
    product_offering,
    product_characteristics = [],
    product = {}
  } = item || {};

  return (
    <div style={{ paddingLeft: 20, marginTop: 4 }}>
      <DefaultDetailRow
        label={translate('PRODUCT')}
        value={product_offering?.name || ''}
        classes={classes}
      />
      <DefaultDetailRow
        label={translate('ACCOUNT')}
        value={account?.name || accountName || ''}
        classes={classes}
      />
      {product_characteristics.map(characteristic => (
        <DefaultDetailRow
          key={characteristic.name}
          label={
            translateLabel(characteristic.name, true) || characteristic.label
          }
          value={characteristic.value}
          classes={classes}
          statusBox={true}
        />
      ))}
      {isDefined(product_offering?.delivery_address) && (
        <DefaultDetailRow
          label={translate('DELIVERY_ADDRESS')}
          value={product_offering?.delivery_address || ''}
          classes={classes}
        />
      )}
      {isDefined(product?.name) && (
        <DefaultDetailRow
          label={translate('REQUEST_NEW_USER.SUBSCRIPTION')}
          value={product?.name || ''}
          classes={classes}
        />
      )}
    </div>
  );
};

export default SubscriptionDetails;
